import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { getProductPackagingPropsAsync } from '../dataActions/DataActionExtension.g';
import { IGetProductPackagingPropsResponse } from '../dataActions/DataServiceEntities.g';

export class GetProductPackagingPropsInput implements Msdyn365.IActionInput {
    public productId: number;
    constructor(productId: number) {
        this.productId = +productId;
    }

    public getCacheKey = () => this.productId.toString();
    public getCacheObjectType = () => 'GetProductPackagingProps';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);

    if (productId) {
        return new GetProductPackagingPropsInput(+productId);
    }

    throw new Error(
        'GetProductPackagingPropsInput input cannot be built, no productId found on module config or query');
};

async function action(input: GetProductPackagingPropsInput, ctx: Msdyn365.IActionContext): Promise<IGetProductPackagingPropsResponse> {
    const response = await getProductPackagingPropsAsync({ callerContext: ctx }, input.productId);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetProductPackagingPropsResponse>>action,
    id: 'GetProductPackagingProps',
    input: createInput
});
